import React, { useState } from "react";
import macauEvent from "../../assets/images/macau-event.jpg";
// import events from "./agenda.json";
import { agendaData } from "./agenda";
import SubHeaderBanner from "../../components/SubHeaderBanner";
import "./style.scss";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <>
          {/* <Box sx={{ p: 3 }}>
                        <Typography>{children}</Typography>
                    </Box> */}
          <div className="index">{children}</div>
        </>
      )}
    </div>
  );
}
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function Agenda() {
  React.useEffect(() => {
    document.body.classList.add("index-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("index-page");
      document.body.classList.remove("sidebar-collapse");
    };
  });

  // const [basicActive, setBasicActive] = useState('tab1');

  // const handleBasicClick = (value) => {
  //     if (value === basicActive) {
  //         return;
  //     }

  //     setBasicActive(value);
  // };

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    event.preventDefault();
  };

  return (
    <>
      {/* <Navbar />*/}
      <SubHeaderBanner title="CONFERENCE AGENDA" image={macauEvent} />
      <div className="wrapper position-relative mb-5">
        <div className="container main mt-5 px-lg-5">
          <h5 className="my-5">
            The ACTnet Global Kick-Off Conference 2026 will be held in Macau.
            The 3.5-day event will consist of keynote speeches, network updates,
            Face-to-Face Meetings, cocktail receptions, and after-conference
            evening events to give all delegates an unforgettable networking
            experience.
          </h5>

          <div className="container" style={{ marginBottom: "200px" }}>
            <div className="col-12 text-left pt-3 d-none d-md-block desktop-table">
              <div className="bg-white shadow px-2 pt-2 pb-3">
                <div className="row">
                  <div className="col-12 text-center">
                    <div className="table-title">
                      <h3 className="title">
                        ACTnet Global Kick-Off Conference 2026 03-06 March
                      </h3>
                    </div>
                  </div>
                </div>

                {agendaData.map((day, dayIndex) => (
                  <div key={dayIndex}>
                    <div className="bg-primary  text-white p-3 text-center">
                      <h5 className="mb-0">{day.date}</h5>
                    </div>
                    <table className="table table-bordered table-striped light-dark agenda-table">
                      <thead>
                        <tr>
                          <th scope="col">Time</th>
                          <th scope="col">Event</th>
                          <th scope="col">Dress Code / Venue</th>
                        </tr>
                      </thead>
                      <tbody>
                        {day.entries.map((entry, entryIndex) => (
                          <tr key={entryIndex}>
                            <td>{entry.time}</td>
                            <td>
                              <span className="fw-bold">{entry.title}</span>
                              {entry.description && (
                                <>
                                  <br />
                                  <span className="fst-italic">
                                    {entry.description}
                                  </span>
                                </>
                              )}
                            </td>
                            <td>{entry.venue}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ))}
              </div>
            </div>

            <div className="container container-padding d-md-none p-0">
              <div class="col-12 force-text-black px-1 pb-2">
                <div class="card">
                  <div class="card-body px-2 py-3">
                    <div className="table-title">
                      <h3 className="title text-center">
                        ACTnet Global Kick-Off Conference 2026 03-06 March
                      </h3>
                    </div>
                    {agendaData.map((day, dayIndex) => (
                      <div key={dayIndex} className="mb-3">
                        <div className="bg-primary  text-white p-3 text-center">
                          <h5 className="mb-0">{day.date}</h5>
                        </div>
                        <table className="table">
                          {day.entries.map((entry, entryIndex) => (
                            <tbody className="border-top">
                              <tr className="bg-light">
                                <td valign="top" width="25%">
                                  Time
                                </td>
                                <td valign="top" className="border-bottom">
                                  {entry.time}
                                </td>
                              </tr>
                              <tr>
                                <td valign="top">Event</td>
                                <td valign="top" className="border-bottom">
                                  <span className="fw-bold">{entry.title}</span>
                                  {entry.description && (
                                    <>
                                      <br />
                                      <span className="fst-italic">
                                        {entry.description}
                                      </span>
                                    </>
                                  )}
                                </td>
                              </tr>
                              <tr>
                                <td valign="top">Dress Code / Venue</td>
                                <td valign="top">{entry.venue}</td>
                              </tr>
                            </tbody>
                          ))}
                        </table>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Agenda;
